
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsSalesmanGroupDialog extends Serenity.EntityDialog<PsSalesmanGroupRow, any> {
        protected getFormKey() { return PsSalesmanGroupForm.formKey; }
        protected getIdProperty() { return PsSalesmanGroupRow.idProperty; }
        protected getLocalTextPrefix() { return PsSalesmanGroupRow.localTextPrefix; }
        protected getNameProperty() { return PsSalesmanGroupRow.nameProperty; }
        protected getService() { return PsSalesmanGroupService.baseUrl; }
        protected getDeletePermission() { return PsSalesmanGroupRow.deletePermission; }
        protected getInsertPermission() { return PsSalesmanGroupRow.insertPermission; }
        protected getUpdatePermission() { return PsSalesmanGroupRow.updatePermission; }

        protected form = new PsSalesmanGroupForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Salesmangroup = Q.tryFirst(PsSalesmanRow.getLookup().items,x => x.SalesmanGroup == this.entity.SalesmanGroup);
            if(Salesmangroup !=null){
                this.deleteButton.toggleClass('disabled', true);
               
            }
        }

       
    }
}